export default function Reputation() {
  const testimonials = [
    {
      name: '小王',
      role: '社区元老成员',
      avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20portrait%20of%20a%20young%20Chinese%20man%20with%20friendly%20smile%2C%20casual%20style%2C%20soft%20lighting%2C%20cream%20background&width=200&height=200&seq=testimonial-1&orientation=squarish',
      quote: '在海角社区找到了很多志同道合的朋友。这里的氛围真的不一样，大家都特别真诚，不像其他平台那么浮躁。每天刷一刷社区，感觉生活都温暖了很多。',
    },
    {
      name: '小美',
      role: '活跃创作者',
      avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20portrait%20of%20a%20young%20Chinese%20woman%20with%20gentle%20smile%2C%20creative%20style%2C%20soft%20lighting%2C%20cream%20background&width=200&height=200&seq=testimonial-2&orientation=squarish',
      quote: '我在这里分享了自己的北漂故事，没想到收到了那么多暖心的留言。海角社区让我明白，原来有这么多人和我有着相似的经历和感受。',
    },
    {
      name: '老张',
      role: '社区志愿者',
      avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20portrait%20of%20a%20middle-aged%20Chinese%20man%20with%20kind%20eyes%2C%20mature%20style%2C%20soft%20lighting%2C%20cream%20background&width=200&height=200&seq=testimonial-3&orientation=squarish',
      quote: '退休后一度觉得生活很空虚，是海角社区让我重新找到了价值感。我在互助问答版块帮年轻人解答问题，感觉自己还是有用的。这个社区对我来说就是一个精神家园。',
    },
    {
      name: '阿琳',
      role: '新成员代表',
      avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20portrait%20of%20a%20young%20Asian%20woman%20with%20bright%20smile%2C%20modern%20style%2C%20soft%20lighting%2C%20cream%20background&width=200&height=200&seq=testimonial-4&orientation=squarish',
      quote: '刚加入海角社区不到一个月，已经爱上了这里。没有广告轰炸，没有无脑撕逼，大家都在认真分享认真交流。推荐给了好几个朋友，都说好！',
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            社区成员心声
          </h2>
          <p className="text-foreground-600">听听海角社区的成员们怎么说</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {testimonials.map((t) => (
            <div key={t.name} className="bg-background-50 rounded-xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-800">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed italic">
                "{t.quote}"
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}